import estasseguroAvatar1 from "../assets/bg/estasseguro-avatar-1.png";

const ESTASSEGURO_AVATARS = [
	estasseguroAvatar1
];

/**
 * Devuelve la URL (bundler) de uno de los avatares «¿estás seguro?» al azar.
 * Usar en cada apertura de modal (no cachear en módulo) para variar entre intentos.
 */
export function getRandomEstasseguroAvatar() {
	return ESTASSEGURO_AVATARS[Math.floor(Math.random() * ESTASSEGURO_AVATARS.length)];
}
